import React from 'react';
import classnames from 'classnames';
import {
  Control,
  FieldErrors,
  useFieldArray,
  UseFormRegister,
} from 'react-hook-form';
import TextArea from 'v2/form/TextArea/TextArea';
import styles from './proposalQuestions.module.scss';
import { ProviderProposalResponseFields } from 'v2/models';

interface ProposalQuestionsProps {
  control: Control<ProviderProposalResponseFields>;
  register: UseFormRegister<ProviderProposalResponseFields>;
  errors: FieldErrors<ProviderProposalResponseFields>;
}

const ProposalQuestions = ({
  control,
  register,
  errors,
}: ProposalQuestionsProps) => {
  const { fields } = useFieldArray({
    control,
    name: 'answers',
  });

  return (
    <>
      {fields.map((question, index) => {
        const errorMsg = errors?.answers?.[index]?.response?.message;
        return (
          <React.Fragment key={question.id}>
            <h5 className="font-weight-bold">{question.question}</h5>
            <input
              className="d-none"
              {...register(`answers.${index}.id` as `answers.${number}.id`)}
            />
            <TextArea
              className={classnames(
                styles.textArea,
                errorMsg ? 'provider-response-error' : ''
              )}
              register={register(
                `answers.${index}.response` as `answers.${number}.response`,
                {
                  required: true,
                }
              )}
              error={errorMsg}
              rows={4}
              autoComplete="off"
              required={true}
              placeholder="Type your answer here..."
              data-cy="proposal-request-question-text-input"
            />
            {errorMsg ? <p className="text-danger">{errorMsg}</p> : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default ProposalQuestions;
